import {
    AllEvents,
    ArticleLikePublication,
    ComponentServices,
    RouteResolution,
    isArticleLikeType,
} from '@news-mono/web-common'
import React from 'react'
import {
    InlineContentTypes,
    InlineTNNewsletterBanner,
} from '../SharedPublication.routing'
import { NewsletterSignup } from '../../../banners/NewsletterSignup/NewsletterSignup'
import { StyledInlineContainer } from '../../../banners/NewsletterSignup/NewsletterSignup.styled'
import { TNNewsletterSignup } from '../../../banners/NewsletterSignup/TNNewsletterSignup'
import { RecaptchaProvider } from '../../../recaptcha/Recaptcha'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { NewsletterVariants } from '../../../banners'

const queryClient = new QueryClient()

export interface getInlinePositionedTNNewsletterBannerProps {
    publication: ArticleLikePublication
    inlinePublicationContent: InlineContentTypes[]
    onEvent: (event: AllEvents) => void
    services: ComponentServices<RouteResolution>
}

export function isInlineTNNewsletterBanner(
    content: InlineContentTypes,
): content is InlineTNNewsletterBanner {
    return content.kind === 'inline-tn-newsletter-banner'
}

export function getInlinePositionedTNNewsletterBanner({
    publication,
    inlinePublicationContent,
    onEvent,
    services,
}: getInlinePositionedTNNewsletterBannerProps) {
    if (!isArticleLikeType(publication)) {
        return []
    }

    return inlinePublicationContent
        .filter(isInlineTNNewsletterBanner)
        .map((content) => {
            const mappedContent = {
                position: content.insertAfter,
                element: (
                    <StyledInlineContainer>
                        {services.config.recaptureSiteKey ? (
                            <RecaptchaProvider
                                siteKey={services.config.recaptureSiteKey}
                            >
                                <QueryClientProvider client={queryClient}>
                                    <InlineTNNewsletterBannerWrapper
                                        text={content.props?.text}
                                        subText={content.props?.subText}
                                        buttonLabel={content.props?.buttonLabel}
                                        mode={
                                            content.props?.mode ||
                                            'inline-article'
                                        }
                                        onEvent={onEvent}
                                        persistent={content.props?.persistent}
                                    />
                                </QueryClientProvider>
                            </RecaptchaProvider>
                        ) : (
                            <></>
                        )}
                    </StyledInlineContainer>
                ),
            }
            return mappedContent
        })
}

const InlineTNNewsletterBannerWrapper: React.FC<{
    text?: string
    subText?: string
    buttonLabel?: string
    onEvent: (event: AllEvents) => void
    mode: NewsletterVariants
    persistent?: boolean
}> = ({
    text = DEFAULT_TEXT,
    subText = DEFAULT_SUBTEXT,
    buttonLabel = DEFAULT_BUTTON_LABEL,
    onEvent,
    mode,
    persistent = false,
}) => {
    return (
        <TNNewsletterSignup
            text={text}
            subText={subText}
            buttonLabel={buttonLabel}
            mode={mode}
            onEvent={onEvent}
            persistent={persistent}
        />
    )
}

const DEFAULT_TEXT = `Sign up to The Nightly's newsletters.`
const DEFAULT_SUBTEXT = `Get the first look at the digital newspaper, curated daily stories and breaking headlines delivered to your inbox.`
const DEFAULT_BUTTON_LABEL = 'Get the Newsletter'
